var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "overview-v2" },
    [
      _c(
        "el-descriptions",
        {
          staticClass: "overview-desc",
          attrs: {
            column: 2,
            border: "",
            size: "samll",
            contentStyle: { width: "40%", padding: "4px 10px" },
            labelStyle: { width: "160px" },
          },
        },
        [
          _c("el-descriptions-item", { attrs: { label: "账号状态" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c(
                "div",
                { staticClass: "desc-left" },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.statusText === "正常" ? "success" : "danger",
                      },
                    },
                    [_vm._v(_vm._s(_vm.statusText))]
                  ),
                  _vm.statusRemarkText
                    ? _c("span", { staticClass: "muted" }, [
                        _vm._v(
                          " (状态备注 " + _vm._s(_vm.statusRemarkText) + ")"
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _c("MemberInfo", {
                    attrs: { compact: "", "member-info": _vm.memberMinInfo },
                    on: { "status-change": _vm.handleStatusChanged },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "账户余额" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _c("span", [_vm._v(_vm._s(_vm.formatYuan(_vm.baseInfo.gold)))]),
                _c("span", { staticClass: "muted" }, [
                  _vm._v(
                    " 剩余打码量 " +
                      _vm._s(_vm.formatYuan(_vm.baseInfo.lock_gold))
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.openAccountChange },
                    },
                    [_vm._v("帐变记录")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.openManualAdjust("up")
                        },
                      },
                    },
                    [_vm._v("手动加款")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.openManualAdjust("down")
                        },
                      },
                    },
                    [_vm._v("手动扣除")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "上级代理" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(_vm._s(_vm.agentText)),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "代理佣金" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(" " + _vm._s(_vm.commissionText) + "  "),
                _c(
                  "span",
                  [
                    _vm._v(" 直属代理 ("),
                    !_vm.baseInfo.share_one_num
                      ? _c("span", [_vm._v(_vm._s(_vm.baseInfo.share_one_num))])
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAgentInviteUserList("direct")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.baseInfo.share_one_num))]
                        ),
                    _vm._v(")"),
                  ],
                  1
                ),
                _vm._v("  "),
                _c(
                  "span",
                  [
                    _vm._v(" 二级代理 ("),
                    !_vm.baseInfo.share_two_num
                      ? _c("span", [_vm._v(_vm._s(_vm.baseInfo.share_two_num))])
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAgentInviteUserList("indirect")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.baseInfo.share_two_num))]
                        ),
                    _vm._v(")"),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "累计充值" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.total_payin_amount)) +
                    "(" +
                    _vm._s(
                      _vm.baseInfo.total_payin_times != null
                        ? _vm.baseInfo.total_payin_times
                        : 0
                    ) +
                    "次) 今日充值 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.today_payin_amount)) +
                    "  历史最大单笔充值 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.payin_amount_max)) +
                    " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.openPayinHistory },
                    },
                    [_vm._v("充值记录")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "累计提现" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.total_payout_amount)) +
                    "(" +
                    _vm._s(
                      _vm.baseInfo.total_payout_times != null
                        ? _vm.baseInfo.total_payout_times
                        : 0
                    ) +
                    "次) 今日提现 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.today_payout_amount)) +
                    "  历史最大单笔提现 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.payout_amount_max)) +
                    " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.openPayoutHistory },
                    },
                    [_vm._v("提现记录")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "充值差额" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  _vm._s(
                    _vm.formatYuan(
                      _vm.baseInfo.payment_win_loss ??
                        _vm.baseInfo.total_payment_win_loss
                    )
                  )
                ),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "资金修正(人工)" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  " 累计加款 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.admin_add_gold)) +
                    "  累计扣除" +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.admin_sub_gold)) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "今日投注" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.today_bet_amount)) +
                    " 总投注 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.total_bet_amount)) +
                    " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.openBetHistory },
                    },
                    [_vm._v("投注统计")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "今日输赢" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  " 输赢金额(" +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.today_win_loss_amount)) +
                    ") 总输赢金额" +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.total_win_loss_amount)) +
                    " (杀分率 " +
                    _vm._s(_vm.winRateText) +
                    ") "
                ),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.handleSetRtp },
                    },
                    [_vm._v("设置玩家RTP")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动优惠" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  " 活动奖励 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.activity_reward)) +
                    " 任务奖励 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.task_reward)) +
                    " 累计返水 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.bet_rebate_gold)) +
                    " 充值优惠 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.payin_bonus)) +
                    " 放弃奖励 " +
                    _vm._s(_vm.formatYuan(_vm.baseInfo.give_up_reward)) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "VIP等级" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  " VIP" +
                    _vm._s(
                      _vm.baseInfo.vip_level != null
                        ? _vm.baseInfo.vip_level
                        : 0
                    ) +
                    " "
                ),
                _c("span", { staticClass: "muted" }, [
                  _vm._v(
                    "(已领取 " +
                      _vm._s(_vm.formatYuan(_vm.baseInfo.vip_reward)) +
                      ")"
                  ),
                ]),
                _vm.baseInfo.next_vip_level != null
                  ? _c("span", { staticClass: "muted" }, [
                      _vm._v(
                        " 距离VIP" +
                          _vm._s(_vm.baseInfo.next_vip_level) +
                          " 充值还差 " +
                          _vm._s(
                            _vm.formatYuan(_vm.baseInfo.next_vip_need_exp)
                          ) +
                          " 下注还差 " +
                          _vm._s(
                            _vm.formatYuan(
                              _vm.baseInfo.next_vip_need_lock_bet_amount
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "会员标签" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [_vm._v("--")]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "登录密码" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(" **** "),
                _vm.baseInfo.same_login_password_num != null
                  ? _c("span", { staticClass: "muted" }, [
                      _vm._v(
                        "同登录密码人数(" +
                          _vm._s(_vm.baseInfo.same_login_password_num) +
                          ")"
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.openModifyLoginPassword },
                    },
                    [_vm._v("修改登录密码")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "提现密码" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(" **** "),
                _vm.baseInfo.same_payout_password_num != null
                  ? _c("span", { staticClass: "muted" }, [
                      _vm._v(
                        "同提现密码人数(" +
                          _vm._s(_vm.baseInfo.same_payout_password_num) +
                          ")"
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.handleResetWithdrawPassword },
                    },
                    [_vm._v("重置提现密码")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "提现账号" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(_vm._s(_vm.baseInfo.payout_card_num || "0") + "个"),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "注册IP" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c(
                "div",
                { staticClass: "desc-left" },
                [
                  _vm.baseInfo.register_ip
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.openIpDetail(_vm.baseInfo.register_ip)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.baseInfo.register_ip))]
                      )
                    : _c("span", [_vm._v("--")]),
                  _c("span", [
                    _vm._v(
                      " 注册时间 " +
                        _vm._s(_vm.formatTs(_vm.baseInfo.register_at))
                    ),
                  ]),
                  _vm.baseInfo.register_days != null
                    ? _c("span", { staticClass: "muted" }, [
                        _vm._v(
                          " (已注册" +
                            _vm._s(_vm.baseInfo.register_days) +
                            "天)"
                        ),
                      ])
                    : _vm._e(),
                  _vm.baseInfo.same_register_ip_num != null
                    ? _c("span", { staticClass: "muted" }, [
                        _vm._v(
                          " 同IP人数(" +
                            _vm._s(_vm.baseInfo.same_register_ip_num) +
                            ")"
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _vm.baseInfo?.black_register_ip === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.openBlacklist(
                                "ip",
                                _vm.baseInfo.register_ip
                              )
                            },
                          },
                        },
                        [_vm._v(" 拉黑IP ")]
                      )
                    : _vm._e(),
                  _vm.baseInfo?.black_register_ip == 1
                    ? _c(
                        "el-popover",
                        {
                          attrs: {
                            title: "",
                            placement: "top",
                            trigger: "hover",
                            content: _vm.baseInfo?.black_register_ip_desc,
                          },
                        },
                        [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                slot: "reference",
                                type: "danger",
                                size: "mini",
                              },
                              slot: "reference",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getBlackStatusText(
                                    _vm.baseInfo?.black_register_ip
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.baseInfo?.black_register_ip == 1
                    ? _c("el-popconfirm", {
                        attrs: { title: "确认移除该条黑名单？" },
                        on: {
                          confirm: function ($event) {
                            return _vm.removeBlacklist(
                              "ip",
                              _vm.baseInfo.register_ip
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "reference",
                              fn: function () {
                                return [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "text", size: "small" } },
                                    [_vm._v("移除")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          631091817
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "注册域名" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(
                  _vm._s(
                    _vm.baseInfo.init_host || _vm.baseInfo.register_host || "--"
                  )
                ),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "注册设备号" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm.baseInfo.register_device
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openDeviceDetail(
                                  _vm.baseInfo.register_device
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.baseInfo.register_device || "--"))]
                        ),
                        _vm._v("(设备号) "),
                      ],
                      1
                    )
                  : _c("span", [_vm._v("--")]),
                _vm.baseInfo.same_register_device_num != null
                  ? _c("span", { staticClass: "muted" }, [
                      _vm._v(
                        " 同注册设备人数(" +
                          _vm._s(_vm.baseInfo.same_register_device_num) +
                          ")"
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _vm.baseInfo?.black_register_device === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.openBlacklist(
                                "device_id",
                                _vm.baseInfo.register_device
                              )
                            },
                          },
                        },
                        [_vm._v(" 拉黑设备 ")]
                      )
                    : _vm._e(),
                  _vm.baseInfo?.black_register_device == 1
                    ? _c(
                        "el-popover",
                        {
                          attrs: {
                            title: "",
                            placement: "top",
                            trigger: "hover",
                            content: _vm.baseInfo?.black_register_device_desc,
                          },
                        },
                        [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                slot: "reference",
                                type: "danger",
                                size: "mini",
                              },
                              slot: "reference",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getBlackStatusText(
                                    _vm.baseInfo?.black_register_device
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.baseInfo?.black_register_device == 1
                    ? _c("el-popconfirm", {
                        attrs: { title: "确认移除该条黑名单？" },
                        on: {
                          confirm: function ($event) {
                            return _vm.removeBlacklist(
                              "device_id",
                              _vm.baseInfo.register_device
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "reference",
                              fn: function () {
                                return [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "text", size: "small" } },
                                    [_vm._v("移除")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          631091817
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "注册浏览器指纹" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(_vm._s(_vm.baseInfo.register_user_agent || "--")),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "注册来源" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(_vm._s(_vm.registerTypeText)),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "最后登录IP" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c(
                "div",
                { staticClass: "desc-left" },
                [
                  _vm.baseInfo.login_ip
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.openIpDetail(_vm.baseInfo.login_ip)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.baseInfo.login_ip))]
                      )
                    : _c("span", [_vm._v("--")]),
                  _vm.baseInfo.same_login_ip_num != null
                    ? _c("span", { staticClass: "muted" }, [
                        _vm._v(
                          " 同IP人数(" +
                            _vm._s(_vm.baseInfo.same_login_ip_num) +
                            ")"
                        ),
                      ])
                    : _vm._e(),
                  _c("span", [
                    _vm._v(
                      " 登录时间 " + _vm._s(_vm.formatTs(_vm.baseInfo.LoginAt))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _vm.baseInfo?.black_login_ip === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.openBlacklist(
                                "ip",
                                _vm.baseInfo.login_ip
                              )
                            },
                          },
                        },
                        [_vm._v(" 拉黑IP ")]
                      )
                    : _vm._e(),
                  _vm.baseInfo?.black_login_ip == 1
                    ? _c(
                        "el-popover",
                        {
                          attrs: {
                            title: "",
                            placement: "top",
                            trigger: "hover",
                            content: _vm.baseInfo?.black_login_ip_desc,
                          },
                        },
                        [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                slot: "reference",
                                type: "danger",
                                size: "mini",
                              },
                              slot: "reference",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getBlackStatusText(
                                    _vm.baseInfo?.black_login_ip
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.baseInfo?.black_login_ip == 1
                    ? _c("el-popconfirm", {
                        attrs: { title: "确认移除该条黑名单？" },
                        on: {
                          confirm: function ($event) {
                            return _vm.removeBlacklist(
                              "ip",
                              _vm.baseInfo.login_ip
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "reference",
                              fn: function () {
                                return [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "text", size: "small" } },
                                    [_vm._v("移除")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          631091817
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "最后登录域名" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm._v(_vm._s(_vm.baseInfo.login_host || "--")),
              ]),
              _c("div", { staticClass: "desc-right" }),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "最后登录设备号" } }, [
            _c("div", { staticClass: "desc-row" }, [
              _c("div", { staticClass: "desc-left" }, [
                _vm.baseInfo.login_device
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openDeviceDetail(
                                  _vm.baseInfo.login_device
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.baseInfo.login_device))]
                        ),
                        _vm._v(" (设备号) "),
                      ],
                      1
                    )
                  : _c("span", [_vm._v("--")]),
                _vm.baseInfo.same_login_device_num != null
                  ? _c("span", { staticClass: "muted" }, [
                      _vm._v(
                        " 同登录设备人数(" +
                          _vm._s(_vm.baseInfo.same_login_device_num) +
                          ")"
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "desc-right" },
                [
                  _vm.baseInfo?.black_login_device === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.openBlacklist(
                                "device_id",
                                _vm.baseInfo.login_device
                              )
                            },
                          },
                        },
                        [_vm._v(" 拉黑设备 ")]
                      )
                    : _vm._e(),
                  _vm.baseInfo?.black_login_device == 1
                    ? _c(
                        "el-popover",
                        {
                          attrs: {
                            title: "",
                            placement: "top",
                            trigger: "hover",
                            content: _vm.baseInfo?.black_login_device_desc,
                          },
                        },
                        [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                slot: "reference",
                                type: "danger",
                                size: "mini",
                              },
                              slot: "reference",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getBlackStatusText(
                                    _vm.baseInfo?.black_login_device
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.baseInfo?.black_login_device == 1
                    ? _c("el-popconfirm", {
                        attrs: { title: "确认移除该条黑名单？" },
                        on: {
                          confirm: function ($event) {
                            return _vm.removeBlacklist(
                              "device_id",
                              _vm.baseInfo.login_device
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "reference",
                              fn: function () {
                                return [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "text", size: "small" } },
                                    [_vm._v("移除")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          631091817
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c("AccountChangeDialogV2", {
        attrs: {
          visible: _vm.dialogs.accountChange,
          uid: _vm.uid,
          "target-info": _vm.targetInfo,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "accountChange", $event)
          },
        },
      }),
      _c("ManualAdjustDialogV2", {
        attrs: {
          visible: _vm.dialogs.manualAdjust,
          uid: _vm.uid,
          "target-info": _vm.targetInfo,
          "member-info": _vm.memberInfoForAdjust,
          mode: _vm.manualAdjustMode,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "manualAdjust", $event)
          },
          success: _vm.handleAdjustSuccess,
        },
      }),
      _c("PayinHistoryDialogV2", {
        attrs: {
          visible: _vm.dialogs.payinHistory,
          uid: _vm.uid,
          "target-info": _vm.targetInfo,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "payinHistory", $event)
          },
        },
      }),
      _c("PayoutHistoryDialogV2", {
        attrs: {
          visible: _vm.dialogs.payoutHistory,
          uid: _vm.uid,
          "target-info": _vm.targetInfo,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "payoutHistory", $event)
          },
        },
      }),
      _c("BetHistoryDialogV2", {
        attrs: {
          visible: _vm.dialogs.betHistory,
          uid: _vm.uid,
          "target-info": _vm.targetInfo,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "betHistory", $event)
          },
        },
      }),
      _c("ModifyLoginPasswordDialog", {
        attrs: {
          visible: _vm.dialogs.modifyLoginPassword,
          "user-info": _vm.modifyLoginUser,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "modifyLoginPassword", $event)
          },
        },
      }),
      _c("SetRtpDialogV2", {
        attrs: {
          visible: _vm.dialogs.setRtp,
          uid: _vm.uid,
          "target-info": _vm.targetInfo,
          "initial-rtp": _vm.baseInfo.rtp,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "setRtp", $event)
          },
          success: _vm.handleSetRtpSuccess,
        },
      }),
      _c("ManageDeviceDetailDialog", {
        attrs: {
          visible: _vm.dialogs.deviceDetail,
          "device-no": _vm.selectedDeviceNo,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "deviceDetail", $event)
          },
        },
      }),
      _c("ManageIpDetailDialog", {
        attrs: { visible: _vm.dialogs.ipDetail, ip: _vm.selectedIp },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "ipDetail", $event)
          },
        },
      }),
      _c("AgentInviteUserListDialog", {
        attrs: {
          visible: _vm.dialogs.agentInviteUserList,
          type: _vm.agentInviteUserListType,
          "inviter-uid": _vm.uid,
          username: _vm.userInfo.username,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.dialogs, "agentInviteUserList", $event)
          },
        },
      }),
      _c("CreateBlackDialog", {
        attrs: {
          visible: _vm.blackDialogVisible,
          row: _vm.blackEditingRow,
          "type-options": _vm.blackTypeOptions,
          "method-options": _vm.blackMethodOptions,
          "lock-type-value": true,
          "account-prefill": _vm.blackAccountPrefill,
        },
        on: {
          "update:visible": function ($event) {
            _vm.blackDialogVisible = $event
          },
          saved: _vm.handleBlacklistSaved,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }